var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColoredwaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 100",
    style: {
      enableBackground: "new 0 0 1000 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.33;fill:url(#SVGID_1_);enable-background:new    ;}\r\n\t.st1{opacity:0.66;fill:url(#SVGID_00000072977493974462760970000000279784649839045772_);enable-background:new    ;}\r\n\t.st2{fill:url(#SVGID_00000040569291057099345650000000698757846413068991_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.489266e-9,
    y1: 49.9992,
    x2: 1000,
    y2: 49.9992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6740E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#50B7ED"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M527,32.7c203.9-88.3,263.1,34,320.3,0C934-19.1,1000,40.3,1000,40.3V100H0l0-59.7c0,0,62.1-26.1,94.9-29.3 c32.8-3.3,62.8,12.3,75.8,22.1c23.3,17.3,84,58.2,134.4,62.2S507.6,41,527,32.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168821833890106648500000003629095074165080714_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.489266e-9,
    y1: 57.7362,
    x2: 1000,
    y2: 57.7362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6740E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#50B7ED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.66,
      fill: "url(#SVGID_00000168821833890106648500000003629095074165080714_)",
      enableBackground: "new"
    },
    d: " M266,32.7c45.5,0,77.2,23.2,129.1,39.1c28.6,8.7,150.3,10.1,254-39.1s91.7,34.4,149.2,0c86-51,201.7,27.5,201.7,27.5V100H0l0-36.5 C0,63.5,28.2,82,92.1,82C189.8,81.9,224.3,32.7,266,32.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148639039111713699330000017963130806694749114_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.489266e-9,
    y1: 70.5296,
    x2: 1000,
    y2: 70.5296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6740E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#50B7ED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148639039111713699330000017963130806694749114_)"
    },
    d: "M233.9,71.1c200,57.5,266-65.5,395.1-19.5 c129,46.6,129,43,186.2,27.8c56.8-15.2,52.5-24.3,94.9-31.9C971.4,36.3,1000,100,1000,100H0c0,0,9.9-40.9,83.6-48.1 S170.4,53,233.9,71.1z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredwaves);
export default __webpack_public_path__ + "static/media/colored waves.338a702106077eaf1640f335e79aa322.svg";
export { ForwardRef as ReactComponent };